import { BranchResponseDto } from "../shared/dtos/branch/BranchResponseDto";
import { BranchSummaryDto } from "../shared/dtos/branch/BranchSummaryDto";

export class BranchMapper {
  public static mapBranchToSummary(
    detailedBranch: BranchResponseDto,
  ): BranchSummaryDto {
    return {
      id: detailedBranch.id,
      name: detailedBranch.name,
      branchCode: detailedBranch.branchCode,
      companyName: detailedBranch.companyName,
      status: detailedBranch.status,
      contactPhone: detailedBranch.contactPhone,
      contactEmail: detailedBranch.contactEmail,
      createdAt: detailedBranch.createdAt,
    };
  }
}
